import { Component, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ClientService } from 'src/app/private/services/client.service';
import { ToastrService } from 'ngx-toastr';
import { EmailHubService } from 'src/app/private/services/email-hub.service';
import { UsersService } from 'src/app/private/services/users.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
@Component({
  selector: 'app-communication-config',
  templateUrl: './communication-config.component.html',
  styleUrls: ['./communication-config.component.scss']
})
export class CommunicationConfigComponent implements OnDestroy {
  outlookForm!: FormGroup;
  isEditMode = false;
  isLoading = false;
  showSecret = false;
  selectedId:any;
 tabs = [
    { key: 'outlook', label: 'Connect Outlook', icon: 'pi pi-envelope' },
    { key: 'gmail', label: 'Connect Gmail', icon: 'pi pi-whatsapp' },

  ];

  currentTab = 'outlook';

  private gmailOAuthPollTimer: ReturnType<typeof setInterval> | null = null;

  constructor(
    private fb: FormBuilder,
    private clientService: ClientService,
    private toastr: ToastrService,
    private outlookApi: EmailHubService,
    private usersService: UsersService,
    private localStorageService: LocalStorageService
  ) {

  }

  changeTab(t: string) {
    this.currentTab = t;
  }

  ngOnDestroy(): void {
    if (this.gmailOAuthPollTimer !== null) {
      clearInterval(this.gmailOAuthPollTimer);
      this.gmailOAuthPollTimer = null;
    }
  }

  connectOutlook() {
  const payload = {
    client_id: this.localStorageService.getClientId(),
    user_id: this.localStorageService.getUserId()
  };

  
  this.outlookApi.getCodeForOutlookToken(payload).subscribe({
    next: (res: any) => {
      const url = res?.message;
      if (!url) {
        this.showError('Failed to start Outlook authentication');
        return;
      }

      this.openOutlookPopup(url);
    },
    error: (err: any) => {
      this.showError('Unable to connect Outlook account');
      console.error(err);
    }
  });
}
getcommunicationPref() {
    return this.localStorageService.getCommincationPref();
}

  /** Show the address for this provider on the settings card (not “active” Mail Hub selection). */
  connectedMailboxEmail(provider: 'outlook' | 'gmail'): string {
    return this.localStorageService.getMailboxEmail(provider);
  }

  /** True if that provider has an OAuth mailbox saved (independent of Mail Hub active switch). */
  commPrefIs(provider: 'outlook' | 'gmail'): boolean {
    return this.localStorageService.hasMailboxConnection(provider);
  }

  private persistCommPrefToDatabase(): void {
    const userId = this.localStorageService.getUserId();
    if (userId == null || userId === '') {
      return;
    }
    this.usersService
      .updateUser({
        user_id: userId,
        commincation_pref: this.localStorageService.getCommPrefPayloadForUser()
      })
      .subscribe({
        error: (err) => console.error('persistCommPrefToDatabase failed', err)
      });
  }

openOutlookPopup(url: string) {
  const width = 600;
  const height = 600;
  const left = window.screen.width / 2 - width / 2;
  const top = window.screen.height / 2 - height / 2;

  const popup = window.open(
    url,
    'OutlookConnect',
    `width=${width},height=${height},top=${top},left=${left}`
  );

  if (!popup) {
      
    this.showError('Popup blocked. Please allow popups and try again.');
    return;
  }

    // Start listening for messages immediately
    window.addEventListener('message', this.handleOutlookMessage, false);

    const timer = setInterval(() => {
      if (popup.closed) {
        clearInterval(timer);
        console.log('Outlook popup closed');
        
        // Trigger loading immediately
        this.isLoading = true;
        
        // Callback Lambda may still be persisting — same retry idea as Gmail OAuth
        this.checkConnectedOutlookEmail(0);
      }
    }, 500); 
  }

showError(message: string) {
  if (message) {
    this.toastr.error(message);
  }
}
showSuccess(message: string) {
  if (message) {
    this.toastr.success(message);
  }
}

  /** Same OAuth flow as Mail Hub: part-d `getCodeForGoogleToken` → popup → `getConnectedGmailEmail`. */
  connectGmail(): void {
    this.isLoading = true;
    this.outlookApi
      .getCodeForGoogleToken({
        client_id: this.localStorageService.getClientId(),
        user_id: this.localStorageService.getUserId()
      })
      .subscribe({
        next: (res: any) => {
          this.isLoading = false;
          const url = res?.message;
          if (!url) {
            this.showError('Failed to start Google sign-in. Check Google OAuth config for this client.');
            return;
          }
          this.openGmailPopup(url);
        },
        error: (err: any) => {
          this.isLoading = false;
          this.showError(err?.error?.message || 'Unable to connect Google account');
          console.error(err);
        }
      });
  }

  private openGmailPopup(url: string): void {
    const width = 600;
    const height = 700;
    const left = window.screen.width / 2 - width / 2;
    const top = window.screen.height / 2 - height / 2;
    const popup = window.open(url, 'GoogleConnectWindow', `width=${width},height=${height},top=${top},left=${left}`);
    if (!popup) {
      this.showError('Popup blocked. Please allow popups and try again.');
      return;
    }
    if (this.gmailOAuthPollTimer !== null) {
      clearInterval(this.gmailOAuthPollTimer);
    }
    this.gmailOAuthPollTimer = setInterval(() => {
      if (popup.closed) {
        if (this.gmailOAuthPollTimer !== null) {
          clearInterval(this.gmailOAuthPollTimer);
          this.gmailOAuthPollTimer = null;
        }
        this.isLoading = true;
        this.syncGmailPreferenceAfterOAuth();
      }
    }, 400);
  }

  private normalizeConnectedGmailResponse(raw: any): Array<{ email_id: string; connected_at?: string }> {
    if (raw == null) {
      return [];
    }
    if (Array.isArray(raw)) {
      return raw;
    }
    if (typeof raw === 'string') {
      try {
        return this.normalizeConnectedGmailResponse(JSON.parse(raw));
      } catch {
        return [];
      }
    }
    if (Array.isArray(raw?.data)) {
      return raw.data;
    }
    if (Array.isArray(raw?.body)) {
      return raw.body;
    }
    if (typeof raw?.body === 'string') {
      try {
        return this.normalizeConnectedGmailResponse(JSON.parse(raw.body));
      } catch {
        return [];
      }
    }
    return [];
  }

  private syncGmailPreferenceAfterOAuth(attempt = 0): void {
    const maxAttempts = 3;
    const retryDelayMs = 800;
    this.outlookApi.getConnectedGmailEmail({ client_id: this.localStorageService.getClientId() }).subscribe({
      next: (raw: any) => {
        const rows = this.normalizeConnectedGmailResponse(raw);
        if (rows.length === 0 && attempt < maxAttempts - 1) {
          setTimeout(() => this.syncGmailPreferenceAfterOAuth(attempt + 1), retryDelayMs);
          return;
        }
        this.isLoading = false;
        if (rows.length === 0) {
          this.showError('No Gmail account found after sign-in. Close this message and try connecting again.');
          return;
        }
        const latest = rows.reduce((best, row) => {
          const t = row.connected_at ? new Date(row.connected_at).getTime() : 0;
          const bt = best.connected_at ? new Date(best.connected_at).getTime() : 0;
          return t >= bt ? row : best;
        });
        const email = latest.email_id;
        if (!email) {
          this.showError('Could not read connected Gmail address.');
          return;
        }
        this.localStorageService.mergeMailboxConnection('gmail', email);
        this.persistCommPrefToDatabase();
        this.showSuccess('Google account connected successfully');
      },
      error: (err: any) => {
        this.isLoading = false;
        this.showError(err?.error?.message || 'Could not verify Gmail connection');
        console.error(err);
      }
    });
  }

  disconnectGmail(): void {
    const email = this.localStorageService.getMailboxEmail('gmail');
    if (!email) {
      this.localStorageService.removeMailboxConnection('gmail');
      this.persistCommPrefToDatabase();
      return;
    }
    this.isLoading = true;
    this.outlookApi
      .disconnectGmail({
        client_id: this.localStorageService.getClientId(),
        email_id: email
      })
      .subscribe({
        next: () => {
          this.isLoading = false;
          this.localStorageService.removeMailboxConnection('gmail');
          this.persistCommPrefToDatabase();
          this.showSuccess('Google account disconnected');
        },
        error: (err: any) => {
          this.isLoading = false;
          this.showError(err?.error?.message || 'Could not disconnect Google account');
          console.error(err);
        }
      });
  }
handleOutlookMessage = (event: MessageEvent) => {
  if (!event?.data?.type) return;

  if (event.data.type === 'OUTLOOK_AUTH_SUCCESS') {
    console.log('Outlook authentication successful message received',event);
    const email = event.data.email;

    this.showSuccess('Outlook account connected successfully');
  }

  if (event.data.type === 'OUTLOOK_AUTH_ERROR') {
    this.showError(event.data.message || 'Outlook authentication failed');
  }

  window.removeEventListener('message', this.handleOutlookMessage);
};

disconnectOutlook() {
  this.revokeOutlookAccess();
  this.showSuccess('Outlook account disconnected successfully');
}

  checkConnectedOutlookEmail(attempt = 0) {
    const maxAttempts = 5;
    const retryDelayMs = 600;
    this.outlookApi
      .getConnectedOutlookEmail({
        client_id: this.localStorageService.getClientId(),
        user_id: this.localStorageService.getUserId()
      })
      .subscribe({
        next: (res: any) => {
          console.log('Connected Outlook email', res);
          const email =
            res?.email ??
            res?.dataValues?.email ??
            (Array.isArray(res) && res[0]?.email ? res[0].email : undefined);
          if (!email && attempt < maxAttempts - 1) {
            setTimeout(() => this.checkConnectedOutlookEmail(attempt + 1), retryDelayMs);
            return;
          }
          if (!email) {
            this.isLoading = false;
            this.showError(
              'Outlook connected but no mailbox email was returned. Try connecting again.'
            );
            return;
          }
          this.localStorageService.mergeMailboxConnection('outlook', email);
          this.persistCommPrefToDatabase();
          this.isLoading = false;
        },
        error: (err: any) => {
          if (attempt < maxAttempts - 1) {
            setTimeout(() => this.checkConnectedOutlookEmail(attempt + 1), retryDelayMs);
            return;
          }
          console.error(err);
          this.isLoading = false;
          this.showError(err?.error?.message || 'Could not verify Outlook connection');
        }
      });
  }

revokeOutlookAccess() {
  const outlookEmail = this.localStorageService.getMailboxEmail('outlook');
  if (!outlookEmail) {
    this.localStorageService.removeMailboxConnection('outlook');
    this.persistCommPrefToDatabase();
    this.showSuccess('Outlook access revoked successfully');
    return;
  }
  this.outlookApi.revokeAccess({
    client_id: this.localStorageService.getClientId(),
    user_id: this.localStorageService.getUserId(),
    email: outlookEmail
  }).subscribe({
    next: (res: any) => {
      console.log('Outlook access revoked', res);
      this.localStorageService.removeMailboxConnection('outlook');
      this.persistCommPrefToDatabase();
      this.showSuccess('Outlook access revoked successfully');
    },
    error: (err: any) => {
      console.error(err);
    }
  });
}

}
